<template>
  <div>
    <div class="text-center">
      <h3 class="mt-2">OTP VERIFICATION</h3>
      <b-img
        :src="img_change_password"
        width="200" />
    </div>
    <div class="text-justify mt-4">
      <p>{{ description }}</p>
    </div>
    <b-form-group
      id="otp-code">
      <input
        v-model="otp.a"
        class="otp"
        maxlength="1"
        type="text"
        @keyup="changeTab(1)">
      <input
        v-model="otp.b"
        class="otp"
        maxlength="1"
        type="text"
        @keyup="changeTab(2)">
      <input
        v-model="otp.c"
        class="otp"
        maxlength="1"
        type="text"
        @keyup="changeTab(3)">
      <input
        v-model="otp.d"
        class="otp"
        maxlength="1"
        type="text"
        @keyup="changeTab(4)">
      <input
        v-model="otp.e"
        class="otp"
        maxlength="1"
        type="text"
        @keyup="changeTab(5)">
      <input
        v-model="otp.f"
        class="otp"
        maxlength="1"
        type="text"
        @keyup="changeTab(6)">
    </b-form-group>
    <div class="command-box text-center">
      <p
        v-if="!expired"
        class="mt-4 mb-4">
        Code is valid for
        <span
          :class="{ 'red' : t_minute == 0 }"
          v-html="t_minute" />
        <span :class="{ 'red' : t_minute == 0 }">:</span>
        <span
          :class="{ 'red' : t_minute == 0 }"
          v-html="t_second"/> minutes.
      </p>
      <p
        v-else
        class="mt-4 mb-1">
        <span class="red">The code you received has expired,</span>
        please enter a new code.
      </p>
      <p v-if="expired">
        <span class="text-shadow">Didn't receive code?
          <a
            class="text-primary resend"
            @click="resendNow">Resend a new code</a>
        </span>
      </p>
    </div>
    <div class="pull-right text-right mb-2">
      <b-button
        class="btn gray m__t--15"
        @click="$emit('close-modal')">
        Close
      </b-button>
      <b-button
        :disabled="enable_verify > 5 && !expired ? false : true"
        class="btn blue m__t--15"
        @click="sendNow">
        Verify
      </b-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    otpShow: {
      type: Boolean,
      default: false,
    },
    waitTime: {
      type: Number,
      default: 1000000,
    },
  },
  data() {
    return {
      description: 'For enhanced security, you are required to enter a one-time password (OTP) to process your login. An email with the OTP has been sent to your email address.',
      t_second: 0,
      t_minute: 0,
      expired: false,
      enable_verify: 0,
      countdown: '',
      otp: {
        a: '',
        b: '',
        c: '',
        d: '',
        e: '',
        f: '',
      },
      form_data: {
        otp: '',
        otp_token: '',
      },
    };
  },
  computed: {
    ...mapState('jStoreLogin', ['data_otp', 'data_login_otp']),

    img_change_password() {
      // eslint-disable-next-line
      return require('@/assets/img/otp-email.png');
    },
  },
  watch: {
    // eslint-disable-next-line
    'otp.a': function (val) {
      if (val) {
        this.enable_verify = this.enable_verify + 1;
        this.form_data.otp = this.otp.a + this.otp.b
        + this.otp.c + this.otp.d + this.otp.e + this.otp.f;
      } else {
        this.enable_verify = this.enable_verify - 1;
      }
    },
    // eslint-disable-next-line
    'otp.b': function (val) {
      if (val) {
        this.enable_verify = this.enable_verify + 1;
        this.form_data.otp = this.otp.a + this.otp.b
        + this.otp.c + this.otp.d + this.otp.e + this.otp.f;
      } else {
        this.enable_verify = this.enable_verify - 1;
      }
    },
    // eslint-disable-next-line
    'otp.c': function (val) {
      if (val) {
        this.enable_verify = this.enable_verify + 1;
        this.form_data.otp = this.otp.a + this.otp.b
        + this.otp.c + this.otp.d + this.otp.e + this.otp.f;
      } else {
        this.enable_verify = this.enable_verify - 1;
      }
    },
    // eslint-disable-next-line
    'otp.d': function (val) {
      if (val) {
        this.enable_verify = this.enable_verify + 1;
        this.form_data.otp = this.otp.a + this.otp.b
        + this.otp.c + this.otp.d + this.otp.e + this.otp.f;
      } else {
        this.enable_verify = this.enable_verify - 1;
      }
    },
    // eslint-disable-next-line
    'otp.e': function (val) {
      if (val) {
        this.enable_verify = this.enable_verify + 1;
        this.form_data.otp = this.otp.a + this.otp.b
        + this.otp.c + this.otp.d + this.otp.e + this.otp.f;
      } else {
        this.enable_verify = this.enable_verify - 1;
      }
    },
    // eslint-disable-next-line
    'otp.f': function (val) {
      if (val) {
        this.enable_verify = this.enable_verify + 1;
        this.form_data.otp = this.otp.a + this.otp.b
        + this.otp.c + this.otp.d + this.otp.e + this.otp.f;
      } else {
        this.enable_verify = this.enable_verify - 1;
      }
    },
    data_otp(val) {
      if (val) {
        this.form_data.otp_token = val.otp_token;
        this.startCount();
      }
    },
    otpShow(val) {
      if (val) {
        const ele = document.querySelectorAll('.otp');
        ele[0].focus();
      } else {
        this.otp = {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
        };
        clearInterval(this.countdown);
      }
    },
  },
  methods: {
    ...mapActions('jStoreLogin', ['loginAccountV2', 'requestOtpLogin']),

    sendNow() {
      const dataLogin = {
        otp: this.form_data.otp,
        otp_token: this.form_data.otp_token,
        ...this.data_login_otp,
      };
      this.loginAccountV2(dataLogin);
    },
    resendNow() {
      this.requestOtpLogin(this.data_login_otp);
    },
    changeTab(val) {
      const ele = document.querySelectorAll('.otp');
      if (val < 7) {
        if (ele[val - 1].value !== '' && val !== 6) {
          ele[val - 0].focus();
        } else if (ele[val - 1].value === '' && val !== 1) {
          ele[val - 2].focus();
        }
      }
    },
    startCount() {
      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      this.expired = false;

      const countDown = this.waitTime;
      this.countdown = setInterval(() => {
        const now = new Date().getTime();
        const distance = countDown - now;
        const tMinute = Math.floor((distance % (hour)) / (minute));
        const tSecond = Math.floor((distance % (minute)) / second);

        this.t_minute = tMinute < 10 ? `0${tMinute}` : tMinute;
        this.t_second = tSecond < 10 ? `0${tSecond}` : tSecond;

        if (distance < 0) {
          clearInterval(this.countdown);
          this.expired = true;
        }
      }, 0);
    },
  },
};
</script>

<style scoped>
#otp-code {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn:disabled{
  background: #c9c9c9;
}

#otp-code label {
  color: #888888;
  font-weight: bold;
}

.box-gray{
  padding: 6px 14px 2px;
  border: 1px solid #f1f1f1;
  border-radius: 8px;
  margin-top: 20px;
}

input.otp{
  display:inline-block;
  width:50px;
  height:50px;
  border: 1px solid #d4d4d4;
  text-align:center;
  border-radius: 8px;
}

.text-shadow{
  color: #cacaca;
}

.command-box{
  font-weight: bold;
}

.resend:hover{
  cursor: pointer;
}

.red {
  color: #f88886;
}

p {
  font-weight: 400 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/jInputOtp.vue